import SwiperCore, { Navigation, Pagination } from 'swiper/core';
SwiperCore.use([Navigation, Pagination]);

export default class Sliders {

    constructor(slider, index) {
        this.slider = slider;
        this.index = index;
        this.slides = Array.from(this.slider.querySelectorAll('.swiper-slide'));
        this.arrows = this.slider.querySelector('.swiper-arrows');

        this.options = this.setOptions();
        this.initSlider();
        
    }

    setOptions() {

        let options = {};

        if(this.slider.classList.contains('swiper--team')) {
            options = {
                grabCursor: true,
                keyboardControl: true,
                navigation: {
                    nextEl: '.swiper-button-next--team',
                    prevEl: '.swiper-button-prev--team',
                },
                pagination: {
                    clickable: 'true',
                    el: '.swiper-pagination--team',
                    type: 'bullets',
                },
                slidesPerView: 1,
                spaceBetween: 20,
                watchOverflow: true,
                breakpoints: {
                    768: {
                        autoplay: {
                            delay: 5000,
                        },
                        centeredSlides: false,
                        grabCursor: true,
                        keyboardControl: true,
                        slidesPerView: "auto",
                        spaceBetween: 60,
                        watchOverflow: true,
                    }
                }
            }
        }

        return options;  
    }

    initSlider() {
        let swiperInstance = new Swiper(this.slider, this.options);
        swiperInstance.init();
        this.swiperInstance = swiperInstance;
    }

    destroy() {
        this.swiperInstance.destroy();
    }

    static init() {
        Sliders.items = Array.from(document.querySelectorAll('.swiper-container')).map((slider, index) => new Sliders(slider, index));
    }

    static destroyAll() {
        Sliders.items.forEach(slider => {
            slider.destroy();
        });
    }
}